<template>
  <svg
    class="absolute top-0 right-0 h-full pointer-events-none translate-x-1/2"
    viewBox="0 0 13 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0 42L11.2164 21.4366C11.7048 20.5411 11.7048 19.4589 11.2164 18.5634L0 -2"
      stroke="#E5E5E5"
    />
  </svg>
</template>
